"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
const react_1 = require("react");
const useInterval = (handler, delay = null) => {
    (0, react_1.useEffect)(() => {
        if (delay === null) {
            return undefined;
        }
        const intervalID = setInterval(handler, delay);
        return () => {
            clearInterval(intervalID);
        };
    }, [delay, handler]);
};
exports.useInterval = useInterval;
//# sourceMappingURL=index.js.map